import {createApp} from 'vue'
import Buefy from 'buefy'
import {buefyConfig, keepalive} from "./ts/utils.js";
import SignIn from "./pages/SignIn.vue";


const app = createApp(SignIn);

//@ts-ignore
app.use(Buefy, buefyConfig)
app.mount('#app')

keepalive(false)
